<mat-slide-toggle
  [color]="'primary'"
  *ngIf="params.value"
  [checked]="params.value.value"
  (change)="onChange($event)"
  [(ngModel)]="params.value.value"
></mat-slide-toggle>
